let ModulesStickyDrawer = {
    Module: require("./modules/Module"),
    Caroussel: require("./modules/ModuleCaroussel"),
    DealsCarousel: require("./modules/ModuleDealsCarousel"),
    Tooltip: require("./modules/ModuleTooltip"),
    StickyDrawer: require("./modules/ModuleStickyDrawer")
};

window.Modules = {...window.Modules, ...ModulesStickyDrawer};